import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { CommonModule } from '@angular/common';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, FormArray, Validators, FormGroupDirective, NgForm } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { ErrorStateMatcher } from '@angular/material/core';
import {AppSettingsService} from '../services/appsettings.service';
import {AppSettings} from '../app.settings';
import { DeviceDetectorService } from 'ngx-device-detector';




@Component({
    selector: 'app-terms-view',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.css']
})
export class TermsComponent implements OnInit {

    model: any = {};
    loading = false;
    returnUrl: string;
    emailid;
    formdata;
    @Input() signupForm: UntypedFormGroup;
    isCompleted: true;
    token: string;
    email: string;
    hideterms = false;
    hidethankyou = true;
    private settings: AppSettings;
    enrollURL: string;
    deviceInfo = null;
inputdatatest = null;


    ResetForm: UntypedFormGroup;
  //  matcher = new MyErrorStateMatcher();




  matcher: ErrorStateMatcher = {
      isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const invalidCtrl = !!(control && control.invalid && control.parent.dirty);
        const invalidParent = !!(control && control.parent && control.parent.invalid && control.parent.dirty);

        return (invalidCtrl || invalidParent);
      }
    };

    validate: ErrorStateMatcher = {
      isErrorState: (control: UntypedFormControl) => {
        return true;
      }
    };


    constructor(private route: ActivatedRoute,
                private router: Router,
                private formBuilder: UntypedFormBuilder,
                private deviceService: DeviceDetectorService,
                private appSettingsService: AppSettingsService,
                private authenticationService: AuthenticationService) {

                  this.appSettingsService.getSettings().subscribe(settings => this.settings = settings,
                    () => null,
                    () => {
                      this.enrollURL = this.settings.enrollServer;
                    });

                }


    ngOnInit() {

        this.loading = false;
        this.inputdatatest = this.signupForm;

      //  this.token = this.route.snapshot.queryParams.token;
     //   this.email = this.route.snapshot.queryParams.email;

        this.initForm();
    }


    signup(fdata) {


        const signupdata = {firstName: fdata.value.firstName,
                            lastName: fdata.value.lastName,
                            email: fdata.value.username,
                            password: fdata.value.password };

        this.loading = true;
        this.authenticationService.SignUpApplicant(signupdata)
            .subscribe(
              async result => {

                const user = result;
                this.loading = false;
                this.hideterms = true;
                this.hidethankyou = false;



                localStorage.setItem('currentUser', JSON.stringify(user));
               // console.log('loginTest', JSON.parse(localStorage.getItem('currentUser')).token);



                },
                error => {
                    this.loading = false;
                    const error1 = error;
                    alert(error1);
                });

    }





    get f() { return this.ResetForm.controls; }


    initForm() {

      }


      populateForm(newaddsarray: UntypedFormGroup) {
        this.signupForm = newaddsarray;

      }



}
